import { loadStripe } from "@stripe/stripe-js";

// Publishable key is safe to expose client-side (unlike the server's
// STRIPE_SECRET_KEY) - loadStripe caches/dedupes internally, but this module
// still only calls it once so every Embedded Checkout mount reuses the same
// promise instead of re-fetching Stripe.js.
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
